import "./App.css";

import Slideshow from "./Slideshow";

function App() {
  return (
    <div className="App">
      <Slideshow />
    </div>
  );
}

export default App;
